import { imgProcessingPostApi } from '../api/ml';
export default async ({ imageData, mlApi }, logger) => {
    return imgProcessingPostApi(imageData, mlApi, true, logger);
};
